import { render, staticRenderFns } from "./WalletTransactionsList.vue?vue&type=template&id=de4b4e68&scoped=true"
import script from "./WalletTransactionsList.vue?vue&type=script&lang=js"
export * from "./WalletTransactionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4b4e68",
  null
  
)

export default component.exports